import { registerStep } from "./stepsRegistry";
import type { StepDefinition } from "./types";
import { PEPAutorizacionesStep } from "@/components/form-steps/PEPAutorizaciones";
import { AutorizacionesSchema } from "@/schemas/multistep/pep-autorizaciones.schema";

const definition: StepDefinition = {
  id: "autorizaciones",
  title: "PEP y autorizaciones",
  schema: AutorizacionesSchema,
  Component: PEPAutorizacionesStep,
  isApplicable: (): boolean => true,
};

registerStep(definition);
